module.exports = __webpack_public_path__ + "media/bg/bg-3-6ecf79db.jpg";